
const instructorMenu = (value) =>  {
    const pathName = [
        'instructor-dashboard', 
        'instructor-appointments', 
        'instructors',
        'instructor-reviews',
        'instructor-invoices',
        'instructor-profile-settings',
        'instructor-social-media',
        'instructor-change-password',
        'instructor-register',
        'instructor-profile',
    ]
    return !!pathName.some(item => item == value);
}

const instructorMapMenu = (value) =>  {
    const pathName = [
        'map-grid', 
        'map-list', 
    ]
    return !!pathName.some(item => item == value);
}

const schoolMenu = (value) =>  {
    const pathName = [
        'map-grid',
        'map-list', 
        'search-school', 
        'school-profile', 
        'school-dashboard', 
        'schedule-timings',
        'booking',
        'booking-success',
        'checkout',
        'invoices',
        'instructor-chat',
        'school-profile-settings',
        'school-change-password'
    ]
    return !!pathName.some(item => item == value);
}

const courseMenu = (value) =>  {
    const pathName = [
        'course-list', 
        'course-details'
    ]
    return !!pathName.some(item => item == value);
}

const pagesMenu = (value) =>  {
    const pathName = [
        'food-list',
        'food-details',
        'food-order',
        'voice-call', 
        'video-call',
        'calendar',
        'components',
        'starter-page',
        'login-page',
        'register-page',
        'forgot-password',
        'invoice-view',
        'blank-page'
    ]
    return !!pathName.some(item => item == value);
}

const invoicesMenu = (value) =>  {
    const pathName = [
        'invoice-view'
    ]
    return !!pathName.some(item => item == value);
}

const blogsMenu = (value) =>  {
    const pathName = [
        'blog-list', 
        'blog-grid',
        'blog-details',
    ]
    return !!pathName.some(item => item == value);
}
export default { instructorMenu, instructorMapMenu, schoolMenu, courseMenu, pagesMenu, invoicesMenu, blogsMenu}


// WEBPACK FOOTER //
// ./src/assets/utils/utils.js